// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"107":"7436f889","971":"d823a0e5"}[chunkId] + ".css";
};